import React, { useState } from "react";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Delete, Keyboard } from "lucide-react";

const ROWS = [
  ["1", "2", "3", "4", "5", "6", "7", "8", "9", "0"],
  ["q", "w", "e", "r", "t", "y", "u", "i", "o", "p"],
  ["a", "s", "d", "f", "g", "h", "j", "k", "l"],
  ["z", "x", "c", "v", "b", "n", "m", "@", "."],
];

export function VirtualKeyboard({ open, onClose, value, onChange }) {
  const [shift, setShift] = useState(false);

  const press = (k) => {
    const ch = shift ? k.toUpperCase() : k;
    onChange((value || "") + ch);
    if (shift) setShift(false);
  };

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent
        className="max-w-3xl p-4 sm:p-6"
        data-testid="virtual-keyboard"
      >
        <div className="rounded-xl border bg-muted/50 px-4 py-3 mb-3 text-lg font-mono min-h-[52px] break-all">
          {value || <span className="text-muted-foreground">…</span>}
        </div>
        <div className="space-y-2 no-select">
          {ROWS.map((row, ri) => (
            <div key={ri} className="flex justify-center gap-1.5">
              {row.map((k) => (
                <button
                  key={k}
                  data-testid={`vk-key-${k}`}
                  onClick={() => press(k)}
                  className="h-12 min-w-[36px] flex-1 max-w-[56px] rounded-lg bg-card border font-semibold text-base hover:bg-primary hover:text-primary-foreground active:scale-95 transition-colors"
                >
                  {shift ? k.toUpperCase() : k}
                </button>
              ))}
            </div>
          ))}
          <div className="flex justify-center gap-1.5">
            <button
              data-testid="vk-shift"
              onClick={() => setShift((s) => !s)}
              className={`h-12 px-4 rounded-lg border font-semibold ${shift ? "bg-primary text-primary-foreground" : "bg-card"}`}
            >
              ⇧
            </button>
            <button
              data-testid="vk-space"
              onClick={() => onChange((value || "") + " ")}
              className="h-12 flex-1 max-w-[280px] rounded-lg bg-card border font-semibold hover:bg-muted"
            >
              espacio
            </button>
            <button
              data-testid="vk-backspace"
              onClick={() => onChange((value || "").slice(0, -1))}
              className="h-12 px-4 rounded-lg bg-card border flex items-center"
            >
              <Delete className="h-5 w-5" />
            </button>
            <Button data-testid="vk-done" onClick={onClose} className="h-12 px-6 rounded-lg">
              OK
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}

export function TouchInput({ value, onChange, placeholder, type = "text", testId, className = "" }) {
  const [open, setOpen] = useState(false);
  return (
    <div className={`relative ${className}`}>
      <input
        data-testid={testId}
        type={type}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        className="w-full min-h-[56px] rounded-xl border bg-card px-4 pr-14 text-base outline-none focus:ring-2 focus:ring-ring transition-shadow"
      />
      <button
        type="button"
        data-testid={testId ? `${testId}-keyboard` : "open-keyboard"}
        onClick={() => setOpen(true)}
        className="absolute right-2 top-1/2 -translate-y-1/2 h-10 w-10 rounded-lg flex items-center justify-center text-muted-foreground hover:bg-muted"
        aria-label="teclado"
      >
        <Keyboard className="h-5 w-5" />
      </button>
      <VirtualKeyboard open={open} onClose={() => setOpen(false)} value={value} onChange={onChange} />
    </div>
  );
}
